import { Card } from 'antd';
import { CreateLayout } from 'components/layout/layout/CreateLayout';
import { FileDoneOutlined } from '@ant-design/icons';
import { FormAssessment } from './components/FormAssessment';
import { IAssessment } from 'interfaces/assessments';
import { PageHeader } from 'components/professor_area/PageHeader';
import { useForm } from '@refinedev/antd';

export const AssessmentCreate = () => {
  const form = useForm<IAssessment>({
    redirect: 'edit'
  });

  return (
    <CreateLayout saveButtonProps={form.saveButtonProps}>
      <PageHeader title="Criar avaliação" icon={FileDoneOutlined} />
      <Card>
        <FormAssessment formInstance={form} />
      </Card>
    </CreateLayout>
  );
};
